<template>
  <div class="complete-register">
    <div class="l-container mx-auto px-4 pb-8">
      <Step :currentStep="2" :steps="steps" />
    </div>
    <div class="l-container pt-4 sm:pt-8">
      <div class="mb-8 pb-8">
        <section>
          <h1 class="text-bold text-left font-24 mb-3">申込完了</h1>
          <hr class="border-a" />
          <div class="font-18 text-under-title">
            お申込みありがとうございました。<br />
            後ほどカスタマーセンターよりメールで詳細をご案内いたします。
          </div>
          <div class="box-info">
            <strong>
              受付番号： <span>{{ get(orderConfirm, 'acptNo') }}</span>
            </strong>
            <br>
            <strong v-if="extSystemCd === 'RakutenT'">
              楽天トラベル予約番号： <span>{{ get(orderConfirm, 'outsideResrvId') }}</span>
            </strong>
            <div class="mt-5">
              <templalte v-if="extSystemCd === 'RakutenT'">
                カスタマーセンターへの問い合わせの際は受付番号、施設への問い合わせの際は楽天トラベル予約番号をお知らせください。
              </templalte>
              <templalte v-else>
                カスタマーセンターへの問い合わせの際は受付番号をお知らせください。
              </templalte>
            </div>
          </div>
        </section>
        <section>
          <h1 class="text-bold text-left font-24 mb-3">お申込み内容</h1>
          <Item :data="dataItemOrder" class="order" />
          <div class="px-4 sm:px-0">
            <div class="flex flex-wrap items-center">
              <div class="w-2/3 sm:w-full float-left">
                <div class="title-box-row">
                  <div class="w-1/4 sm:w-full">宿泊期間</div>
                  <div class="w-3/4 sm:w-full">
                    <span class="mr-2">{{
                      customerPlan ? customerPlan.stayDayJP : ''
                    }}</span>
                    <span class="mr-2"
                      >{{ customerPlan ? customerPlan.stayNights : '' }} 泊</span
                    >
                    <span class="mr-2"
                      >{{ customerPlan ? customerPlan.stayRooms : '' }} 部屋</span
                    >
                    （大人{{ get(orderConfirm, 'totalAdult') }}名/子ども{{
                      get(orderConfirm, 'totalChild')
                    }}名）
                  </div>
                </div>
                <div class="title-box-row">
                  <div class="w-1/4 sm:w-full">チェックイン</div>
                  <div class="w-3/4 sm:w-full">{{ value_time_picker }}:00</div>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-price flex justify-between mt-5">
            <div class="flex-auto">
              <div class="item-left">宿泊料合計（税込)</div>
              <div class="item-left text-dark">（うち消費税（10%）</div>
              <div v-if="isShowSubsidyAmount || totalApplyBenepoints" class="item-left text-dark">
                ＜補助クーポン・ベネポ申請＞
              </div>
              <div v-if="isShowSubsidyAmount" class="item-left text-dark">補助クーポン申請額</div>
              <div v-if="get(orderConfirm, 'aplyCafePointAmt', 0) > 0" class="item-left max-h-64">カフェテリアポイント申請額</div>
              <div v-if="totalApplyBenepoints !== ''" class="item-left">ベネポ申請額</div>
              <div v-if="isPayeeDivMethodLocal===false" class="item-left text-bold border-t-2">クレジットカード支払額</div>
              <div v-else class="item-left text-bold border-t-2">現地支払予定額</div>
              <div class="item-left" v-if="getGrantedBenepo != null">獲得予定ベネポ</div>
            </div>
            <div class="right">
              <div class="">
                {{ get(orderConfirm, 'feePeople', 0) | formatCurrency }}
              </div>
              <div class="text-dark">
                {{
                  Math.round(get(orderConfirm, 'feePeople', 0) * (1 / 11)) | formatCurrency
                }}
              </div>
              <div v-if="isShowSubsidyAmount || totalApplyBenepoints" class="text-dark">
                {{ "&nbsp;" }}
              </div>
              <div v-if="isShowSubsidyAmount" class="red-text text-dark">
                {{ get(orderConfirm, 'aplySbsidAmt', 0) | formatCurrency }}
              </div>
              <div v-if="get(orderConfirm, 'aplyCafePointAmt', 0) > 0" class="red-text max-h-64">
                {{ get(orderConfirm, 'aplyCafePointAmt', 0) | formatCurrency }}
              </div>
              <div v-if="totalApplyBenepoints" class="red-text">
                {{ totalApplyBenepoints }}
              </div>
              <div class="right-content text-bold border-t-2">{{ get(orderConfirm, 'totalCost') | formatCurrency }}</div>
              <div class="blue-text" v-if="getGrantedBenepo != null">{{ (getGrantedBenepo || 0) + "ベネポ" }}</div>
            </div>
          </div>
        </section>
        <section class="my-8">
          <div class="share-options">
            <!-- ライフエール独自対応 ↓↓↓↓↓ -->
            <!-- <Share label="シェアする" :url="shareUrl" :info="getInfoForShareButton"/> -->
            <!-- ライフエール独自対応 ↑↑↑↑↑ -->
            <div class="flex items-center sm:mt-4" @click="handleMove()">
              <a class="text-black"> お申し込みの詳細を見る </a>
              <span class="icon icon-bor-arrow-right sm color-primary"></span>
            </div>
          </div>
          <div v-if="isPayeeDivMethodLocal">
            <div class="buttons_inner">
              <!-- <button @click="showPopupAttach('同行者の補助金・ポイント申請')" v-if="checkSrvicDiv()" class="c-btn btn-grey">
                  <span class="">同行者の補助金・ポイントを申請する</span>
              </button> -->
              <div class="buttons hidden">
                <button @click="showPopupAttach('同行者申請')" class="c-btn btn-grey">
                  <span class="">宿泊同行者を申請する</span>
                </button>
                <a-button
                  @click="handleNext()"
                  v-if="extSystemCd === 'RakutenT'"
                  disabled
                  class="c-btn btn-rakuten h-auto"
                >
                  <span class="">ロープライス・ギャランティーを申請する</span>
                </a-button>
                <a-button @click="handleNext()" v-else class="c-btn btn-grey h-auto">
                  <span class="">ロープライス・ギャランティーを申請する</span>
                </a-button>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div v-if="questionList && questionList.length > 0">
            <a-divider />
            <h1 class="text-bold text-left font-24 my-3">ご確認事項</h1>
            <div class="checklist" v-for="(item, index) in questionList" :key="index">
              <div class="main-checklist">
                <div class="checklist-title">
                  {{ item.qstnCont }}
                  <div class="w-8 ml-1 mt-1 category" v-if="item.replyIdpsbFlag === '1'">
                    必須
                  </div>
                </div>
                <div class="checklist-content" v-if="item.replyRem">
                  <div class="pl-5 py-4" wovn-ignore >
                    <p wovn-ignore v-html="item.replyRem" style="white-space: pre-wrap"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="btn-attach">
          <button @click="redirecToTopPage()" class="c-btn btn-grey">
            <!-- ライフエール独自対応 ↓↓↓↓↓ -->
            <!-- <span class="">BSTOPに戻る</span> -->
            <span class="">TOPに戻る</span>
            <!-- ライフエール独自対応 ↑↑↑↑↑ -->
          </button>
        </section>

        <section class="hidden">
          <SectionContentTitle
            class="my-4"
            :lineType="lineType.vertical"
            :titleContent="titleContent[2]"
          />
          <div class="mb-4">
            <span>チェックを入れた内容の新着メニュー・プラン情報をお届けします。 </span>
          </div>
          <div class="flex gap-x-8 mb-4 sm:flex-col sm:gap-y-4">
            <a-checkbox v-model="checkboxValue" class="m-0">
              デイリーマガジン
            </a-checkbox>
            <a-checkbox v-model="checkboxValue1" class="m-0"> 週刊マガジン </a-checkbox>
            <a-checkbox v-model="checkboxValue2" class="m-0"> 月間マガジン </a-checkbox>
          </div>
          <div class="flex flex-col mb-4">
            <span>
              ※配信頻度は「あなたへのオススメ」の設定内容に準じたものとなります。
            </span>
            <span>
              ※配信停止は、マイページ「会員プロフィール設定」からお願いします。
            </span>
          </div>
          <div>
            <a-button size="large" @click="gotoPath" class="text-bold">設定する</a-button>
          </div>
        </section>
      </div>
    </div>
    <AttachPerson
      :visible="visiblePopupAttachPerson"
      :acptNo="getAcptNo"
      :acptDtlNo="getAcptDtlNo"
      :process="modalTitle"
      @cancel="closePopup"
      @ok="attachPeople"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import get from 'lodash/get'
import Share from './components/Share'
import AttachPerson from './components/attachPerson'

import { Item, Step, SectionContentTitle } from '@/components/compound'
import { GET_SAME_CATEGORY_MENUS } from '@/store/modules/menu/actions.js'
import { CANCEL_ORDER, CREATE_ORDER } from '@/store/modules/plan/actions'
import { STEPS } from '@/constants/order.js'

export default {
  components: {
    Item,
    Step,
    SectionContentTitle,
    Share,
    AttachPerson
  },
  data() {
    return {
      steps: STEPS,
      customerPlan: '',
      recommendedItems: [],
      orderInfo: null,
      finalOrderAmount: 0,
      ckinSchDatetime: '',
      value_time_picker: '',
      showPopUp: false,
      totalAdult: '',
      totalChild: '',
      pointBenepo: 0,
      dataItemOrder: {
        type: 'type-small',
        label: '',
        menu_id: '',
        menu_content: '',
        title1: '',
        title2: ''
      },
      info_lives: '',
      titleContent: [
        'お申し込み内容',
        '確認事項',
        '新着情報受信設定',
        '周辺のおすすめサービス',
        '確認事項'
      ],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      receipt_number: null,
      reservation_number: null,
      checkboxValue: false,
      checkboxValue1: false,
      checkboxValue2: false,
      flag: false,
      catNm: '',
      catLrgClassNm: '',
      catMidClassNm: '',
      catSmlClassNm: '',
      dataItem: {
        type: 'type-small',
        label: 'アジア・エスニック',
        menu_id: 'メニューNo. 123456',
        menu_content: 'お申し込み種別：お申し込み',
        title1: '相鉄フレッサイン 浜松町大門（施設名',
        title2:
          'スタンダードシンプル＆ベーシック＜素泊まり＞プラン 【禁煙】レディースダブル（プラン名）'
      },
      visiblePopupAttachPerson: false,
      extSystemCd: null,
      orderConfirm: null,
      questionList: null,
      modalTitle: '',
      contractInfo: [],
      srvicDiv: '',
      boSrvCd: '',
      isPayeeDivMethodLocal: true
    }
  },
  created() {
    // 事前決済用のsessionStorage格納値削除
    sessionStorage.removeItem('confirmQuery')
    const documentTitle = sessionStorage.getItem('documentTitle', document.title)
    if(documentTitle){
      sessionStorage.removeItem('documentTitle')
      this.$meta.setDocumentTitle(documentTitle)
    }
  },
  mounted() {
    const payeeDivMethod = _.get(this.$store.state.order, 'payeeDivMethod', null)
    if (payeeDivMethod == "credit") {
      this.isPayeeDivMethodLocal = false;
    }
    let orderData = _.get(this.$store.state, 'order.originCalendar', null)
    if (orderData === null) {
      this.$router.push("/interrupt")
      return
    }

    this.questionList = this.getQuestionList
    this.orderConfirm = _.cloneDeep(this.$store.getters['order/get'].orderConfirm)
    this.extSystemCd = _.get(this.customerPlanState, 'extSystemCd', null)
    this.getPlanBasicInfo()
    this.mountData()
    this.customerPlan = this.customerPlanState
    this.getSameCategoryMenus()
    this.getContractInfo()
    this.$store.commit('order/setResetState')
  },
  computed: {
    getAcptNo() {
      return this.orderInfo ? this.orderInfo.acptNo : null
    },
    getAcptDtlNo() {
      return this.orderInfo ? this.orderInfo.acptDtlNo : null
    },
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    },
    getOrderInfo() {
      return _.cloneDeep(this.$store.getters.orderDetail)
    },
    customerPlanState() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.customerPlan', null))
    },
    getQuestionList() {
      return _.cloneDeep(
        _.get(this.$store.state, 'bs_app.bs_app.bs_app_02_001.questionList', null)
      )
    },
    mypageURL() {
      return process.env.VUE_APP_MYPAGE_DOMAIN
    },
    shareUrl() {
      const { menuNo } = this.$route.query
      return `${location.protocol}//${location.host}/bs-02-001?menuNo=${menuNo}`
    },
    getInfoForShareButton() {
      const planBasicInfo = this.getPlanInfo ? this.getPlanInfo.planBasicInfo : null
      const menuInformation = this.getPlanInfo ? this.getPlanInfo.menuInformation : null
      const info = {
        menuName : menuInformation?.menuNm,
        planName : planBasicInfo?.planNm
      }
      return info
    },
    totalApplyBenepoints() {
      const totalApplyBenepoints = 
        Math.ceil(
          get(this.orderConfirm, 'fee4', 0) +
          get(this.orderConfirm, 'applyBenepoints', 0)
        )
      return totalApplyBenepoints > 0 ? (totalApplyBenepoints.toLocaleString() + "ベネポ") : "";
    },
    getGrantedBenepo() {
      const grantedBenepo = this.orderConfirm?.grantedBenepo;
      if (grantedBenepo){
        return grantedBenepo.toLocaleString();
      }
      return grantedBenepo;
    },
    isShowSubsidyAmount() {
      return get(this.orderConfirm, 'aplySbsidAmt', 0) > 0;
    },
    pointRemain() {
      return _.get(this.$store.getters, 'bs_app.bs_app_02_008.pointRemain', 0)
    },
    isRakuten() {
      return _.get(this.getPlanInfo, 'menuInformation.extSystemCd', null) === 'RakutenT';
    },
  },
  methods: {
    get,
    getSameCategoryMenus() {
      const { catLrgClassCd, catMidClassCd, catSmlClassCd } = _.get(
        this.getPlanInfo,
        'menuInformation.categoryInfomation',
        ''
      )
      this.$store
        .dispatch(GET_SAME_CATEGORY_MENUS, {
          catLrgClassCd,
          catMidClassCd,
          catSmlClassCd
        })
        .then((data) => {
          if (data) {
            this.recommendedItems = data
            this.recommendedItems.forEach((ele) => {
              const catLrgClassNm = _.get(ele, 'categoryInfomation.catLrgClassNm', null)
              const catMidClassNm = _.get(ele, 'categoryInfomation.catMidClassNm', null)
              const catSmlClassNm = _.get(ele, 'categoryInfomation.catSmlClassNm', null)
              const dataCat = {
                catLrgClassNm,
                catMidClassNm,
                catSmlClassNm
              }
              ele.category = this.getCatNm(dataCat)
            })
          }
        })
    },
    showConfirm() {
      const context = this
      this.$confirm({
        title: 'オーダーをキャンセルします。よろしいでしょうか。',
        content: '',
        onOk() {
          context.handleCancelOrder()
          return new Promise((resolve, reject) => {
            setTimeout(Math.random() > 0.5 ? resolve : reject, 1000)
          }).catch(() => console.log(''))
        },
        onCancel() {}
      })
    },
    isStayRequest() {
      const orderInfo = this.getOrderInfo;
      if (orderInfo.acptDtlStayRequestList) {
        return true;
      } else {
        return false;
      }
    },
    async mountData() {
      // 楽天に再ログインした場合
      if (this.$route.query.fromR === '1') {
        this.$loading.show();
        // ライフエール独自対応
        // if (this.pointRemain) {
        //   this.$auth.points = this.pointRemain;
        // }
        const result = this.getOrderInfo;
        await this.$store.dispatch(CREATE_ORDER, result).then(
          (data) => {
            if(data){
              this.orderConfirm['acptNo'] = data.acptNo
              this.orderConfirm['acptDtlNo'] = data.acptDtlNo
              // 楽天の場合は、楽天トラベル予約番号を完了画面で表示する必要がある
              if (this.isRakuten) {
                this.orderConfirm['outsideResrvId'] = data.outsideResrvId
              }
            }
            else {
              this.$router.push("/interrupt")
            }
          },
          (error) => {
            this.$router.push("/interrupt")
          }
        )
        this.$loading.hide()
      }
      // 事前決済時処理
      if(this.isPayeeDivMethodLocal === false && !this.orderConfirm.acptNo){
        this.$loading.show()
        const param = this.getOrderInfo
        if (param.totalCost) {
          delete param.totalCost
        }
        const p = this.$route.query.param
        if (param.param) {
          delete param.param
        }
        const reserveId = param.reserveId
        if (param.reserveId) {
          delete param.reserveId
        }
        param['orderId'] = _.get(this.$store.state.order, 'orderId', null)
        param['p'] = p
        await this.$repositories('order').orderPay(reserveId, param).then(
          (data) => {
            if(data){
              this.getOrderInfo['acptNo'] = data.acptNo
              this.getOrderInfo['acptDtlNo'] = data.acptDtlNo
              this.getOrderInfo['transactionId'] = data.transactionId
              this.orderConfirm['acptNo'] = data.acptNo
              this.orderConfirm['acptDtlNo'] = data.acptDtlNo
            }
            else {
              this.$router.push("/interrupt")
            }
          },
          (error) => {
            this.$router.push("/interrupt")
          }
        )
        this.$loading.hide()
      }
      const bs_app_02_001 = _.cloneDeep(
        _.get(this.$store.state, 'bs_app.bs_app.bs_app_02_001', null)
      )
      const bs_app_02_008 = _.cloneDeep(
        _.get(this.$store.state, 'bs_app.bs_app.bs_app_02_008', null)
      )
      const bs_app_02_005 = _.cloneDeep(
        _.get(this.$store.state, 'bs_app.bs_app.bs_app_02_005', null)
      )
      if (bs_app_02_008) {
        this.pointBenepo = _.get(bs_app_02_008, 'point_benepo', 0)
      }
      if (bs_app_02_001) {
        this.value_time_picker = _.get(bs_app_02_001, 'checkinTime', '')
        this.info_lives = bs_app_02_001.info_lives
        this.ckinSchDatetime = _.get(bs_app_02_001, 'othInfo.ckinSchDatetime', '')
      }

      this.finalOrderAmount = _.get(bs_app_02_005, 'totalCost', '')
      // this.finalOrderAmount = this.$store.getters['order/get'].orderDetail.totalCost

      const orderInfo = this.getOrderInfo
      if (orderInfo) {
        this.orderInfo = orderInfo
        if (this.isStayRequest()) {
          this.totalAdult =
            _.get(
              orderInfo,
              'acptDtlStayRequestList[0].stayAcptDtl.adultTotalHeadCnt',
              ''
            ) +
            _.get(
              orderInfo,
              'acptDtlStayRequestList[0].stayAcptDtl.vistrAdultTotalHeadCnt',
              ''
            )
          this.totalChild =
            _.get(orderInfo, 'acptDtlStayRequestList[0].stayAcptDtl.chldHeadCnt', '') +
            _.get(orderInfo, 'acptDtlStayRequestList[0].stayAcptDtl.vistrChldHeadCnt', '')
          if (
            Array.isArray(orderInfo.acptDtlStayRequestList) &&
            orderInfo.acptDtlStayRequestList.length &&
            orderInfo.acptDtlStayRequestList[0].dtlChrgTotal
          ) {
            // if(_.get(orderInfo, 'acptDtlDomesticStayList[0].dtlChrgTotal.billAmtTotal', '') <= 0) {
            //   this.pointBenepo = 0
            // }
            // this.finalOrderAmount = _.get(orderInfo, 'acptDtlDomesticStayList[0].dtlChrgTotal.billAmtTotal', '') - this.pointBenepo
          }
          this.srvicDiv = orderInfo.acptDtlStayRequestList[0].acptDtl.srvicDiv

        } else {
          this.totalAdult =
            _.get(
              orderInfo,
              'acptDtlDomesticStayList[0].stayAcptDtl.adultTotalHeadCnt',
              ''
            ) +
            _.get(
              orderInfo,
              'acptDtlDomesticStayList[0].stayAcptDtl.vistrAdultTotalHeadCnt',
              ''
            )
          this.totalChild =
            _.get(orderInfo, 'acptDtlDomesticStayList[0].stayAcptDtl.chldHeadCnt', '') +
            _.get(orderInfo, 'acptDtlDomesticStayList[0].stayAcptDtl.vistrChldHeadCnt', '')
          if (
            Array.isArray(orderInfo.acptDtlDomesticStayList) &&
            orderInfo.acptDtlDomesticStayList.length &&
            orderInfo.acptDtlDomesticStayList[0].dtlChrgTotal
          ) {
            // if(_.get(orderInfo, 'acptDtlDomesticStayList[0].dtlChrgTotal.billAmtTotal', '') <= 0) {
            //   this.pointBenepo = 0
            // }
            // this.finalOrderAmount = _.get(orderInfo, 'acptDtlDomesticStayList[0].dtlChrgTotal.billAmtTotal', '') - this.pointBenepo
          }
          this.srvicDiv = orderInfo.acptDtlDomesticStayList[0].acptDtl.srvicDiv

        }
      }
    },

    getCatNm(dataCatNm) {
      if (
        !dataCatNm.catLrgClassNm &&
        !dataCatNm.catMidClassNm &&
        dataCatNm.catSmlClassNm
      ) {
        return `${dataCatNm.catSmlClassNm}`
      }
      if (
        !dataCatNm.catLrgClassNm &&
        dataCatNm.catMidClassNm &&
        !dataCatNm.catSmlClassNm
      ) {
        return `${dataCatNm.catMidClassNm}`
      }
      if (
        dataCatNm.catLrgClassNm &&
        !dataCatNm.catMidClassNm &&
        dataCatNm.catSmlClassNm
      ) {
        return `${dataCatNm.catLrgClassNm}`
      }
      if (
        !dataCatNm.catLrgClassNm &&
        dataCatNm.catMidClassNm &&
        dataCatNm.catSmlClassNm
      ) {
        return `${dataCatNm.catMidClassNm}・${dataCatNm.catSmlClassNm}`
      }
      if (
        dataCatNm.catLrgClassNm &&
        !dataCatNm.catMidClassNm &&
        dataCatNm.catSmlClassNm
      ) {
        return `${dataCatNm.catLrgClassNm}・${dataCatNm.catSmlClassNm}`
      }
      if (
        dataCatNm.catLrgClassNm &&
        dataCatNm.catMidClassNm &&
        !dataCatNm.catSmlClassNm
      ) {
        return `${dataCatNm.catLrgClassNm}・${dataCatNm.catMidClassNm}`
      }
      if (dataCatNm.catLrgClassNm && dataCatNm.catMidClassNm && dataCatNm.catSmlClassNm) {
        return `${dataCatNm.catLrgClassNm}・${dataCatNm.catMidClassNm}・${dataCatNm.catSmlClassNm}`
      }
      return null
    },

    handleMove() {
      const menuNo = this.$route.query.menuNo
      let srvicDiv;
      if (this.isStayRequest()) {
        srvicDiv = this.orderInfo.acptDtlStayRequestList[0].acptDtl.srvicDiv;
      } else {
        srvicDiv = this.orderInfo.acptDtlDomesticStayList[0].acptDtl.srvicDiv
      }

      const params = {
        acptNo: this.orderInfo.acptNo,
        srvicDiv: srvicDiv,
        isPublicStay: srvicDiv !== 'A10' && srvicDiv.startsWith('A')
      }

      window.location.href =
        this.mypageURL +
        `/mypage/orders/${menuNo}?acptNo=${params.acptNo}&srvicDiv=${params.srvicDiv}&isPublicStay=${params.isPublicStay}`
      // this.$router.push({ path: `/mypage/orders/${menuNo}`, query: params })
    },
    redirecToTopPage() {
      window.location.href = process.env.VUE_APP_TOP_DOMAIN
    },
    showPopupAttach(title) {
      this.modalTitle = title;
      this.visiblePopupAttachPerson = true
    },
    async getContractInfo() {
      await this.$repositories("user").contractInfo()
        .then((res) => {  
          this.contractInfo = res.data.contractInfo
          this.boSrvCd = res.data.contractInfo[0].subscriptions.find((x) => x.boServiceCode === "BS").boServiceCode;
        })
    },
    // 同行者助成申請ボタン制御
    checkSrvicDiv() {
      console.log("srvicDiv:",this.srvicDiv);
      console.log("BboServCode:",this.boSrvCd);
      console.log("env:",process.env.VUE_APP_MAP_BO_CODE)   

      if(this.srvicDiv == 'A10' || this.srvicDiv == 'A15' || this.srvicDiv == 'A20' || this.srvicDiv == 'A25' || this.srvicDiv == 'B55'){
        if(process.env.VUE_APP_MAP_BO_CODE == 'BS'){
          return true;
        }
      }
      return false;
    },
    closePopup() {
      this.visiblePopupAttachPerson = false
    },
    attachPeople() {
      this.visiblePopupAttachPerson = false
    },
    handleNext() {
      const acptNo = this.orderInfo.acptNo
      const query = { acptNo }
      // navigate to payment gateway
      this.$router.push({ path: '/low-price', query })
    },
    handleEdit() {
      const query = this.$route.query
      this.$router.push({ path: '/register-rooms', query })
    },
    getPlanBasicInfo() {
      const planBasicInfo = this.getPlanInfo ? this.getPlanInfo.planBasicInfo : null
      const roomBasicInfo = this.getPlanInfo ? this.getPlanInfo.roomBasicInfo : null
      const title2Text = this.getTitle2Text(planBasicInfo, roomBasicInfo)
      if (planBasicInfo && roomBasicInfo) {
        this.dataItemOrder = {
          type: 'type-small',
          menu_id: _.get(planBasicInfo, 'menuNo', ''),
          label: _.get(this.getPlanInfo, 'menuInformation.categoryInfomation', ''),
          baseImg: planBasicInfo.planImages[0].imageUrl,
          title1: _.get(this.getPlanInfo, 'menuInformation.menuNm', ''),
          title2: title2Text
        }
      }
    },
    getTitle2Text(planBasicInfo, roomBasicInfo) {
      // 楽天の場合は、プラン名のみ表示する
      if (this.extSystemCd === 'RakutenT') {
        return _.get(planBasicInfo, 'planNm', '')
      }
      return _.get(planBasicInfo, 'planNm', '') + _.get(roomBasicInfo, 'roomNm', '')
    },
    handleCancelOrder() {
      const data = {
        setlSts: '10',
        acptDtlDomesticStayCancelList: [
          {
            dtlChrgTotal: {
              acptDtlNo: this.orderInfo.acptDtlNo
            }
          }
        ]
      }
      data.acptNo = this.orderInfo.acptNo
      this.$store.dispatch(CANCEL_ORDER, data).then(
        () => {
          this.$toasted.success('オーダーがキャンセルされました。')
        },
        (err) => {
          const error = err.error
          this.$toasted.error(error && error.message ? error.message : error)
        }
      )
    },
    copyContent() {
      return location.href
    },
    copySuccess() {
      this.$toasted.success('Copied')
    },
    copyError() {
      this.$toasted.error('Copy failed')
    },
    gotoPath() {
      const query = this.$route.query
      this.$router.push({ path: '/mypage/setting', query })
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
